import { useParams } from 'react-router-dom';

import { useMatterContext } from '@/providers/MatterProvider';

export const useMatter = () => {
  // First check if there's a MatterProvider context
  const matterContext = useMatterContext();

  // Always call useParams (React hooks must be called unconditionally)
  const { matter_id: routeMatterId } = useParams<{ matter_id: string }>();

  // Prefer context over route params
  const matterId = matterContext?.matterId || routeMatterId;

  if (!matterId) {
    throw new Error(
      'useMatter must be used within a route that has a matter_id param or wrapped in a MatterProvider',
    );
  }

  return { matterId };
};
